import React from "react";
import { Input } from "antd";


function HexTextInput({
  label,
  required = false,
  value,
  onChange,
  placeholder,
  type = "text",
  maxLength,
  showCount = false,
  disabled = false,
  numericOnly = false,
  capitalizeFirst = false,
  prefix,
  suffix,
  className = "",
  wrapperClassName = "",
  status,
  errorText,
  ...rest
}) {
  const labelClass = "text-xs font-bold text-slate-500 uppercase tracking-wider";

  const handleChange = (e) => {
    let val = e.target.value;

    // when type="number", only allow digits (no alphabets, no e/+/-/.)
    // numericOnly prop does the same for text-type phone fields
    if (numericOnly || type === "number") {
      const re = /^[0-9\b]*$/;
      if (!re.test(val)) return; // ignore non-numeric keystrokes
    }

    // hard lock at maxLength ourselves — don't rely only on the native
    // HTML attribute, since it doesn't always cut controlled values reliably
    if (maxLength && val.length > maxLength) {
      val = val.slice(0, maxLength);
    }

    if (capitalizeFirst && val.length > 0) {
      val = val.charAt(0).toUpperCase() + val.slice(1);
    }

    if (onChange) onChange(val);
  };

  return (
    <div className={`flex flex-col gap-1.5 ${wrapperClassName}`}>
      {label && (
        <div className="flex justify-between items-center">
          <label className={labelClass}>
            {label} {required && <span className="text-red-500">*</span>}
          </label>
          {showCount && maxLength && (
            <span className="text-[10px]  font-bold">
              {(value?.length ?? 0)}/{maxLength}
            </span>
          )}
        </div>
      )}

      <Input
        type={type === "number" ? "text" : type}
        inputMode={type === "number" || numericOnly ? "numeric" : undefined}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        prefix={prefix}
        suffix={suffix}
        status={status}
style={{height:"38px"}}
        className={`hex-input ${className}`}
        {...rest}
      />

      {errorText && (
        <span className="text-[11px] text-red-500 font-medium">{errorText}</span>
      )}
    </div>
  );
}

export default HexTextInput;


